import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { BRAND } from "../mock";

export const Logo = () => (
  <Link to="/" className="logo" data-testid="logo">{BRAND.name}<em>{BRAND.accent}</em></Link>
);

export const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

const Nav = () => {
  const { user, openAuth } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const go = (id) => (loc.pathname === "/" ? scrollTo(id) : nav(`/#${id}`));
  return (
    <nav className="topnav" data-testid="main-nav">
      <Logo />
      <div className="nav-btns">
        <button className="nav-link hide-sm" onClick={() => go("news")} data-testid="nav-news">News</button>
        <button className="nav-link hide-sm" onClick={() => go("pricing")} data-testid="nav-pricing">Pricing</button>
        <button className="nav-link hide-sm" onClick={() => go("how")} data-testid="nav-how">How It Works</button>
        <button className={`nav-link ${loc.pathname === "/results" ? "active" : ""}`} onClick={() => nav("/results")} data-testid="nav-results">Results</button>
        {user ? (
          <button className="nav-btn nb-login" onClick={() => nav("/dashboard")} data-testid="nav-dashboard">Dashboard</button>
        ) : (
          <button className="nav-btn nb-login" onClick={() => openAuth("login")} data-testid="nav-login">Member Login</button>
        )}
        <button className="nav-btn nb-access" onClick={() => go("pricing")} data-testid="nav-get-access">Get Access</button>
      </div>
    </nav>
  );
};

export default Nav;
